import { css } from "@emotion/css";
import { theme } from "assets/theme";
import { Text } from "components";
import { differenceInDays } from "date-fns";
import React from "react";

// at the 1st of next month
const resetDate = new Date();
resetDate.setMonth(resetDate.getMonth() + 1);
resetDate.setDate(1);
resetDate.setHours(0, 0, 0, 0);
const resetIn = differenceInDays(resetDate, new Date());

type Props = {
  value: number;
  max: number;
};
export const CreditProgress: React.FC<Props> = ({ value, max }) => {
  if (value < 0 || max === 0) {
    return null;
  }
  const progress = (value / max) * 100;
  const getBackgroundColor = (currentProgress: number) => {
    if (currentProgress < 90) {
      return theme.colors.text["highlight/1"];
    } else {
      return theme.colors.accent["red/main"];
    }
  };
  return (
    <div
      className={css`
        width: 100%;
        margin-top: 20px;
      `}
    >
      <div
        className={css`
          width: 100%;
          height: 7px;
          background-color: #0d0d0d;
          border-radius: 100px;
          overflow: hidden;
        `}
      >
        <div
          className={css`
            width: ${progress > 100 ? 100 : progress}%;
            height: 100%;
            background-color: ${getBackgroundColor(progress)};
            border-radius: 100px;
          `}
        />
      </div>

      <div
        className={css`
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          margin-top: 8px;
        `}
      >
        <Text.Body3XS color="seconday">
          {value}/{max} EMAILS
        </Text.Body3XS>
        <Text.Body3XS color="seconday">Resets in {resetIn} days</Text.Body3XS>
      </div>
    </div>
  );
};
